<ng-container *ngIf="{
  timings: displayTimings$ | async
} as obs">
  <ion-item *ngIf="obs.timings as timings">
    <ion-select interface="popover"
                [disabled]="!timings?.length && !showAsapOption"
                [value]="value$ | async"
                (ionChange)="onSelectChange($event)">
      <ion-select-option *ngIf="showAsapOption" [value]="0">ASAP</ion-select-option>
      <ion-select-option *ngFor="let timing of timings" [value]="timing.id">
        {{timing.displayTime}}
      </ion-select-option>
    </ion-select>
  </ion-item>
</ng-container>